import React from 'react'
export const VectorDown = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12.248"
      height="7.003"
      viewBox="0 0 12.248 7.003"
    >
      <path
        id="Icon_ionic-ios-arrow-down"
        data-name="Icon ionic-ios-arrow-down"
        d="M12.314,16.138,16.945,11.5a.872.872,0,0,1,1.236,0,.883.883,0,0,1,0,1.24l-5.247,5.251a.874.874,0,0,1-1.207.026L6.443,12.747a.875.875,0,0,1,1.236-1.24Z"
        transform="translate(-6.188 -11.246)"
        fill="#fff"
      />
    </svg>
  )
}
export const Info = () => {
  return (
    <svg
      id="info_1_"
      data-name="info (1)"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.138"
          y1="0.366"
          x2="0.957"
          y2="0.711"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#c03dfd" />
          <stop offset="1" stopColor="#4f81fd" />
        </linearGradient>
      </defs>
      <path
        id="Path_88254"
        data-name="Path 88254"
        d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z"
        fill="url(#linear-gradient)"
      />
      <path
        id="Path_88255"
        data-name="Path 88255"
        d="M12,10H11a1,1,0,0,0,0,2h1v6a1,1,0,0,0,2,0V12A2,2,0,0,0,12,10Z"
        transform="translate(0 0)"
        fill="url(#linear-gradient)"
      />
      <circle
        id="Ellipse_703"
        data-name="Ellipse 703"
        cx="1.5"
        cy="1.5"
        r="1.5"
        transform="translate(10.5 5)"
        fill="url(#linear-gradient)"
      />
    </svg>
  )
}
export const Shield = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="20"
      height="24"
      viewBox="0 0 20 24"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.138"
          y1="0.366"
          x2="0.957"
          y2="0.711"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#c03dfd" />
          <stop offset="1" stopColor="#4f81fd" />
        </linearGradient>
      </defs>
      <path
        id="shield"
        d="M18.581,2.14,12.316.051a1,1,0,0,0-.632,0L5.418,2.14A4.993,4.993,0,0,0,2,6.883V12c0,7.563,9.2,11.74,9.594,11.914a1,1,0,0,0,.812,0C12.8,23.74,22,19.563,22,12V6.883A4.993,4.993,0,0,0,18.581,2.14ZM20,12c0,5.455-6.319,9.033-8,9.889-1.683-.853-8-4.42-8-9.889V6.883A3,3,0,0,1,6.051,4.037L12,2.054l5.948,1.983A3,3,0,0,1,20,6.883Z"
        transform="translate(-2 0)"
        fill="url(#linear-gradient)"
      />
    </svg>
  )
}
export const Details = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="21.671"
      height="24.725"
      viewBox="0 0 21.671 24.725"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.073"
          y1="0.5"
          x2="0.968"
          y2="0.851"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#c03dfd" />
          <stop offset="1" stopColor="#4f81fd" />
        </linearGradient>
      </defs>
      <path
        id="Union_14"
        data-name="Union 14"
        d="M-4576.942,24.725A2.061,2.061,0,0,1-4579,22.666V2.058A2.061,2.061,0,0,1-4576.942,0h11.831a3.925,3.925,0,0,1,2.257,1.035,21.934,21.934,0,0,1,2.4,2.094,21.773,21.773,0,0,1,2.094,2.4,3.925,3.925,0,0,1,1.035,2.257V22.666a2.061,2.061,0,0,1-2.058,2.058Zm-.231-22.666V22.666a.237.237,0,0,0,.231.231h17.555a.237.237,0,0,0,.232-.231V7.933h-5.193a.915.915,0,0,1-.914-.914V1.826h-11.68A.238.238,0,0,0-4577.173,2.058Zm13.738,4.047h3.212a21.966,21.966,0,0,0-1.527-1.685,22.2,22.2,0,0,0-1.685-1.527Zm-10.073,14.04a.915.915,0,0,1-.914-.914.915.915,0,0,1,.914-.914h10.687a.914.914,0,0,1,.912.914.914.914,0,0,1-.912.914Zm0-3.053a.915.915,0,0,1-.914-.914.914.914,0,0,1,.914-.912h10.687a.913.913,0,0,1,.912.912.914.914,0,0,1-.912.914Zm0-3.053a.914.914,0,0,1-.914-.912.915.915,0,0,1,.914-.914h10.687a.913.913,0,0,1,.912.914.913.913,0,0,1-.912.912Z"
        transform="translate(4579)"
        fill="url(#linear-gradient)"
      />
    </svg>
  )
}
export const Matic = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="19.149"
      height="19.153"
      viewBox="0 0 19.149 19.153"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_19853"
            data-name="Rectangle 19853"
            width="12.551"
            height="10.999"
          />
        </clipPath>
      </defs>
      <g id="polygon-matic-seeklogo.com" transform="translate(0)">
        <path
          id="Path_288"
          data-name="Path 288"
          d="M155.371,45.4h0a9.578,9.578,0,0,1,9.578,9.578h0a9.574,9.574,0,0,1-9.575,9.575h0a9.574,9.574,0,0,1-9.575-9.575h0A9.571,9.571,0,0,1,155.371,45.4Z"
          transform="translate(-145.8 -45.4)"
          fill="#8247e5"
        />
        <g
          id="Group_831"
          data-name="Group 831"
          transform="translate(3.229 4.141)"
        >
          <g
            id="Group_830"
            data-name="Group 830"
            transform="translate(0 0)"
            clipPath="url(#clip-path)"
          >
            <path
              id="Path_289"
              data-name="Path 289"
              d="M241.077,157.76a.825.825,0,0,0-.784,0l-1.831,1.085-1.243.69-1.8,1.081a.825.825,0,0,1-.784,0l-1.405-.855a.8.8,0,0,1-.392-.69v-1.643a.814.814,0,0,1,.392-.69l1.405-.821a.825.825,0,0,1,.784,0l1.405.855a.8.8,0,0,1,.392.69v1.085l1.243-.723v-1.115a.814.814,0,0,0-.392-.69l-2.615-1.545a.825.825,0,0,0-.784,0l-2.679,1.579a.727.727,0,0,0-.392.656v3.086a.814.814,0,0,0,.392.69l2.649,1.545a.825.825,0,0,0,.784,0l1.8-1.051,1.243-.723,1.8-1.051a.825.825,0,0,1,.784,0l1.405.821a.8.8,0,0,1,.392.69v1.643a.814.814,0,0,1-.392.69l-1.372.821a.825.825,0,0,1-.784,0l-1.409-.821a.8.8,0,0,1-.392-.69v-1.051l-1.243.723v1.085a.814.814,0,0,0,.392.69l2.649,1.545a.825.825,0,0,0,.784,0l2.649-1.545a.8.8,0,0,0,.392-.69v-3.12a.814.814,0,0,0-.392-.69Z"
              transform="translate(-231.596 -154.41)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
export const Clock = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.583"
      height="14.583"
      viewBox="0 0 14.583 14.583"
    >
      <path
        id="Icon_material-watch-later"
        data-name="Icon material-watch-later"
        d="M10.292,3a7.292,7.292,0,1,0,7.292,7.292A7.313,7.313,0,0,0,10.292,3Zm3.062,10.354L9.562,11.021V6.646h1.094v3.792l3.281,1.969Z"
        transform="translate(-3 -3)"
        fill="#99acd2"
      />
    </svg>
  )
}

export const Comment = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="18.734"
      height="16.58"
      viewBox="0 0 18.734 16.58"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#c03dfd" />
          <stop offset="1" stopColor="#4f81fd" />
        </linearGradient>
      </defs>
      <path
        id="Icon_awesome-comment-dots"
        data-name="Icon awesome-comment-dots"
        d="M8.617,1.5a10.4,10.4,0,0,1,6.566,2.218,7.107,7.107,0,0,1,2.8,5.533,7.107,7.107,0,0,1-2.8,5.533A10.4,10.4,0,0,1,8.617,17a11,11,0,0,1-3.485-.561A8.4,8.4,0,0,1,.269,18.08a1.02,1.02,0,0,1-.738-1.722,8.194,8.194,0,0,0,1.545-2.507A6.919,6.919,0,0,1-.75,9.251a7.107,7.107,0,0,1,2.8-5.533A10.4,10.4,0,0,1,8.617,1.5Zm0,14c4.338,0,7.867-2.8,7.867-6.251S12.955,3,8.617,3,.75,5.8.75,9.251a5.436,5.436,0,0,0,1.7,3.87l.3.3-.1.411a8.153,8.153,0,0,1-1.3,2.654,7.262,7.262,0,0,0,3.189-1.472l.333-.265.4.15A9.484,9.484,0,0,0,8.617,15.5ZM4.309,7.424A1.827,1.827,0,1,1,2.481,9.251,1.829,1.829,0,0,1,4.309,7.424Zm0,2.154a.327.327,0,1,0-.327-.327A.328.328,0,0,0,4.309,9.579ZM8.617,7.424A1.827,1.827,0,1,1,6.79,9.251,1.829,1.829,0,0,1,8.617,7.424Zm0,2.154a.327.327,0,1,0-.327-.327A.328.328,0,0,0,8.617,9.579Zm4.309-2.154A1.827,1.827,0,1,1,11.1,9.251,1.829,1.829,0,0,1,12.926,7.424Zm0,2.154a.327.327,0,1,0-.327-.327A.328.328,0,0,0,12.926,9.579Z"
        transform="translate(0.75 -1.5)"
        fill="url(#linear-gradient)"
      />
    </svg>
  )
}

export const Share = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="16.625"
      height="14.722"
      viewBox="0 0 16.625 14.722"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#c03dfd" />
          <stop offset="1" stopColor="#4f81fd" />
        </linearGradient>
      </defs>
      <path
        id="Icon_awesome-share"
        data-name="Icon awesome-share"
        d="M9.283,1.55h0a1.408,1.408,0,0,1,.919.344l5.234,4.52a1.414,1.414,0,0,1,0,2.14L10.2,13.074A1.413,1.413,0,0,1,7.864,12V10.11c-2.133.1-3.384.487-3.911,1.216-.483.667-.474,1.772.028,3.378a1.178,1.178,0,0,1-.174,1.06,1.257,1.257,0,0,1-1.01.509,1.236,1.236,0,0,1-.731-.239A6.772,6.772,0,0,1-.7,10.884,5.288,5.288,0,0,1,2.165,5.818a13.2,13.2,0,0,1,5.7-1.158v-1.7a1.393,1.393,0,0,1,.443-1.029A1.423,1.423,0,0,1,9.283,1.55Zm0,10.468,0,0,5.234-4.52a.011.011,0,0,0,0-.01.011.011,0,0,0,0-.01L9.287,2.954l0,0a.035.035,0,0,0-.018.007s0,0,0,.007V6.037l-.692.008A12.97,12.97,0,0,0,2.817,7.057,3.888,3.888,0,0,0,.7,10.884a5.3,5.3,0,0,0,1.785,3.685c-.476-1.8-.367-3.1.334-4.064.889-1.227,2.6-1.77,5.735-1.815l.71-.01V12c0,.01,0,.01,0,.01A.079.079,0,0,0,9.282,12.018Z"
        transform="translate(0.7 -1.55)"
        fill="url(#linear-gradient)"
      />
    </svg>
  )
}

export const Heart = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="17.932"
      height="16.553"
      viewBox="0 0 17.932 16.553"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#c03dfd" />
          <stop offset="1" stopColor="#4f81fd" />
        </linearGradient>
      </defs>
      <path
        id="Icon_ionic-md-heart-empty"
        data-name="Icon ionic-md-heart-empty"
        d="M16.376,4.5a5.3,5.3,0,0,0-4.035,1.892A5.3,5.3,0,0,0,8.306,4.5,4.875,4.875,0,0,0,3.375,9.462c0,3.427,3.048,6.177,7.664,10.419l1.3,1.173,1.3-1.173c4.617-4.242,7.664-6.992,7.664-10.419A4.875,4.875,0,0,0,16.376,4.5ZM12.893,18.7l-.181.168-.371.336-.371-.336-.181-.168A54.791,54.791,0,0,1,6.5,13.436,6.325,6.325,0,0,1,4.759,9.462,3.585,3.585,0,0,1,5.78,6.905,3.508,3.508,0,0,1,8.306,5.879a3.953,3.953,0,0,1,2.979,1.4l1.056,1.254L13.4,7.28a3.939,3.939,0,0,1,2.979-1.4,3.525,3.525,0,0,1,2.53,1.026,3.593,3.593,0,0,1,1.022,2.556,6.358,6.358,0,0,1-1.741,3.974A54.9,54.9,0,0,1,12.893,18.7Z"
        transform="translate(-3.375 -4.5)"
        fill="url(#linear-gradient)"
      />
    </svg>
  )
}
export const TopNFT = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="23.314"
      height="31.086"
      viewBox="0 0 23.314 31.086"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#4f81fd" />
          <stop offset="1" stopColor="#c03dfd" />
        </linearGradient>
      </defs>
      <path
        id="Icon_awesome-fire"
        data-name="Icon awesome-fire"
        d="M13.114,1.449A1.46,1.46,0,0,0,10.434.657C2.914,11.648,13.6,12.143,13.6,17.486a3.886,3.886,0,1,1-7.771-.058V12.236a1.457,1.457,0,0,0-2.515-1A12.14,12.14,0,0,0,0,19.429a11.657,11.657,0,0,0,23.314,0c0-10.339-10.2-11.718-10.2-17.98Z"
        fill="url(#linear-gradient)"
      />
    </svg>
  )
}

export const CollectionActivity = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="24.363"
      height="20.29"
      viewBox="0 0 24.363 20.29"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#c03dfd" />
          <stop offset="1" stopColor="#4f81fd" />
        </linearGradient>
      </defs>
      <path
        id="Path_88256"
        data-name="Path 88256"
        d="M3603.184,468.944a.8.8,0,0,1-.677-.373l-10.322-16.351v6.736a.8.8,0,0,1-.8.8h-5.848a.8.8,0,1,1,0-1.6h5.048v-8.7a.8.8,0,0,1,1.477-.427l10.322,16.351v-5.8a.8.8,0,0,1,.8-.8h5.117a.8.8,0,1,1,0,1.6h-4.317v7.762a.8.8,0,0,1-.8.8Z"
        transform="translate(-3584.738 -448.653)"
        fill="url(#linear-gradient)"
      />
    </svg>
  )
}

export const CollectionItems = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="19.473"
      height="18.69"
      viewBox="0 0 19.473 18.69"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#c03dfd" />
          <stop offset="1" stopColor="#4f81fd" />
        </linearGradient>
      </defs>
      <g
        id="Group_63337"
        data-name="Group 63337"
        transform="translate(-44.758 -488.405)"
      >
        <path
          id="Union_16"
          data-name="Union 16"
          d="M-3133.357,18.653l-9.332-3.809a.5.5,0,0,1-.273-.652.5.5,0,0,1,.652-.275l9.133,3.728,8.945-4.037a.5.5,0,0,1,.662.249.5.5,0,0,1-.249.661l-9.141,4.127a.5.5,0,0,1-.206.044A.491.491,0,0,1-3133.357,18.653Zm0-3.825-9.332-3.809a.5.5,0,0,1-.273-.652.5.5,0,0,1,.652-.274l9.133,3.727,8.945-4.037a.5.5,0,0,1,.662.25.5.5,0,0,1-.249.661l-9.141,4.126a.5.5,0,0,1-.206.045A.492.492,0,0,1-3133.357,14.828Zm0-3.824-9.332-3.809a.5.5,0,0,1-.273-.653.5.5,0,0,1,.652-.274l9.133,3.728,8.945-4.038a.5.5,0,0,1,.662.25.5.5,0,0,1-.249.661L-3132.962,11a.514.514,0,0,1-.206.044A.508.508,0,0,1-3133.357,11Zm-.241-3.76-8.508-3.208a.5.5,0,0,1-.323-.472.5.5,0,0,1,.33-.467l8.507-3.068a.5.5,0,0,1,.17-.03.5.5,0,0,1,.169.03l8.508,3.068a.5.5,0,0,1,.33.467.5.5,0,0,1-.323.472l-8.508,3.208a.51.51,0,0,1-.177.032A.5.5,0,0,1-3133.6,7.244Zm-6.887-3.666,7.063,2.663,7.062-2.663-7.062-2.547Z"
          transform="translate(3187.759 488.405)"
          fill="url(#linear-gradient)"
        />
      </g>
    </svg>
  )
}
export const CollectionOffer = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="18.692"
      height="18.69"
      viewBox="0 0 18.692 18.69"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#c03dfd" />
          <stop offset="1" stopColor="#4f81fd" />
        </linearGradient>
      </defs>
      <path
        id="Path_88256"
        data-name="Path 88256"
        d="M11.923,20.89a2.539,2.539,0,0,1-1.808-.75l-7.69-7.681a.765.765,0,0,1-.224-.541V2.965A.765.765,0,0,1,2.965,2.2h8.953a.765.765,0,0,1,.541.224l7.691,7.691a2.562,2.562,0,0,1,0,3.6l-6.421,6.421A2.538,2.538,0,0,1,11.923,20.89ZM3.73,11.6,11.2,19.059a1.026,1.026,0,0,0,1.452,0l6.42-6.42a1.028,1.028,0,0,0,0-1.445L11.6,3.73H3.73Z"
        transform="translate(-2.2 -2.2)"
        fill="url(#linear-gradient)"
      />
    </svg>
  )
}
// Collection Social icons
export const Twitter = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12.268"
      height="12.268"
      viewBox="0 0 12.268 12.268"
    >
      <path
        id="Icon_awesome-twitter-square"
        data-name="Icon awesome-twitter-square"
        d="M10.954,2.25H1.314A1.315,1.315,0,0,0,0,3.564V13.2a1.315,1.315,0,0,0,1.314,1.314h9.639A1.315,1.315,0,0,0,12.268,13.2V3.564A1.315,1.315,0,0,0,10.954,2.25ZM9.615,6.6c.005.077.005.156.005.233a5.075,5.075,0,0,1-5.11,5.11,5.086,5.086,0,0,1-2.758-.805,3.784,3.784,0,0,0,.433.022,3.6,3.6,0,0,0,2.229-.767A1.8,1.8,0,0,1,2.736,9.145a1.936,1.936,0,0,0,.811-.033A1.8,1.8,0,0,1,2.109,7.349V7.327a1.8,1.8,0,0,0,.811.227,1.792,1.792,0,0,1-.8-1.5,1.774,1.774,0,0,1,.244-.906,5.1,5.1,0,0,0,3.7,1.879A1.8,1.8,0,0,1,9.13,5.391a3.519,3.519,0,0,0,1.139-.433,1.791,1.791,0,0,1-.789.989,3.574,3.574,0,0,0,1.035-.279A3.78,3.78,0,0,1,9.615,6.6Z"
        transform="translate(0 -2.25)"
        fill="#99acd2"
      />
    </svg>
  )
}
export const Facebook = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12.268"
      height="12.268"
      viewBox="0 0 12.268 12.268"
    >
      <path
        id="Icon_ionic-logo-facebook"
        data-name="Icon ionic-logo-facebook"
        d="M16.091,4.5H5.177a.678.678,0,0,0-.677.677V16.091a.678.678,0,0,0,.677.677h5.457V11.912H9.168V10.123h1.466V8.8a2.331,2.331,0,0,1,2.514-2.447c.677,0,1.406.051,1.575.073V8.081H13.6c-.77,0-.917.364-.917.9v1.141h1.834l-.24,1.789H12.679v4.856h3.412a.678.678,0,0,0,.677-.677V5.177A.678.678,0,0,0,16.091,4.5Z"
        transform="translate(-4.5 -4.5)"
        fill="#99acd2"
      />
    </svg>
  )
}
export const Chat = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11.765"
      height="13.037"
      viewBox="0 0 11.765 13.037"
    >
      <path
        id="Icon_simple-discord"
        data-name="Icon simple-discord"
        d="M12.1,0A1.429,1.429,0,0,1,13.52,1.344V13.037L12.066,11.8l-.8-.727-.871-.759.364,1.2H3.135a1.348,1.348,0,0,1-1.38-1.345V1.347A1.375,1.375,0,0,1,3.137,0H12.1ZM8.781,3.087H8.764l-.11.109a4.376,4.376,0,0,1,1.671.835,5.909,5.909,0,0,0-2.034-.618,5.585,5.585,0,0,0-1.344,0H6.839a4.843,4.843,0,0,0-1.526.4c-.254.11-.4.183-.4.183A3.876,3.876,0,0,1,6.657,3.16l-.073-.073a3.264,3.264,0,0,0-1.889.69,8.5,8.5,0,0,0-.98,3.813,2.37,2.37,0,0,0,2.033.981s.217-.29.437-.544a2.149,2.149,0,0,1-1.162-.763,1.8,1.8,0,0,1,.182.109h.033a.043.043,0,0,1,.033.016v0a.042.042,0,0,0,.033.016c.179.074.359.147.505.217a4.444,4.444,0,0,0,.978.291,5.579,5.579,0,0,0,1.744,0,5.02,5.02,0,0,0,.978-.291,7.836,7.836,0,0,0,.759-.4,2.159,2.159,0,0,1-1.2.763c.179.253.432.543.432.543a2.835,2.835,0,0,0,2.1-.938,8.484,8.484,0,0,0-.986-3.813A3.267,3.267,0,0,0,8.75,3.1l.03-.011Zm.091,2.4a.727.727,0,1,1-.69.728.708.708,0,0,1,.69-.728Zm-2.468,0a.727.727,0,1,1-.692.728A.708.708,0,0,1,6.4,5.484Z"
        transform="translate(-1.755)"
        fill="#99acd2"
      />
    </svg>
  )
}
export const PostImageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="20.787"
      height="20.788"
      viewBox="0 0 20.787 20.788"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#c03dfd" />
          <stop offset="1" stopColor="#4f81fd" />
        </linearGradient>
      </defs>
      <path
        id="images"
        d="M7.8,4.764a1.3,1.3,0,1,1,1.3,1.3A1.3,1.3,0,0,1,7.8,4.764Zm12.993-.433v5.2a4.332,4.332,0,0,1-4.331,4.331h-7.8A4.332,4.332,0,0,1,4.331,9.528v-5.2A4.332,4.332,0,0,1,8.662,0h7.8A4.332,4.332,0,0,1,20.788,4.331ZM6.063,9.528a2.607,2.607,0,0,0,.667,1.741L11.269,6.73a2.3,2.3,0,0,1,3.179,0l.9.9a.528.528,0,0,0,.736,0L19.056,4.66V4.331a2.606,2.606,0,0,0-2.6-2.6h-7.8a2.606,2.606,0,0,0-2.6,2.6Zm12.993,0V7.111l-1.75,1.75a2.3,2.3,0,0,1-3.179,0l-.9-.9a.528.528,0,0,0-.736,0L8.341,12.109a1.936,1.936,0,0,0,.32.017h7.8A2.606,2.606,0,0,0,19.056,9.528Zm-3.387,6.1a.869.869,0,0,0-1.065.606l-.251.918a2.552,2.552,0,0,1-1.221,1.568,2.584,2.584,0,0,1-1.975.251L3.638,16.908a2.6,2.6,0,0,1-1.819-3.2l.832-3.084a.867.867,0,0,0-1.672-.459L.156,13.244a4.34,4.34,0,0,0,3.032,5.327l7.518,2.061a4.392,4.392,0,0,0,1.152.156A4.349,4.349,0,0,0,16.033,17.6l.251-.918a.869.869,0,0,0-.606-1.065Z"
        transform="translate(-0.001 0)"
        fill="url(#linear-gradient)"
      />
    </svg>
  )
}
export const PostVideoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="18.234"
      height="18.234"
      viewBox="0 0 18.234 18.234"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#c03dfd" />
          <stop offset="1" stopColor="#4f81fd" />
        </linearGradient>
      </defs>
      <path
        id="film_1_"
        data-name="film (1)"
        d="M14.436,0H3.8A3.8,3.8,0,0,0,0,3.8V14.436a3.8,3.8,0,0,0,3.8,3.8H14.436a3.8,3.8,0,0,0,3.8-3.8V3.8A3.8,3.8,0,0,0,14.436,0Zm.76,8.357h1.52v1.52H15.2Zm0-1.52V5.318h1.52v1.52Zm-1.52,1.52H4.559V1.52h9.117ZM3.039,9.877H1.52V8.357h1.52Zm0-3.039H1.52V5.318h1.52ZM1.52,11.4h1.52v1.52H1.52Zm3.039-1.52h9.117v6.838H4.559ZM15.2,11.4h1.52v1.52H15.2Zm1.52-7.6H15.2V1.659A2.279,2.279,0,0,1,16.715,3.8ZM3.039,1.659V3.8H1.52a2.279,2.279,0,0,1,1.52-2.139ZM1.52,14.436h1.52v2.139A2.279,2.279,0,0,1,1.52,14.436ZM15.2,16.575V14.436h1.52A2.279,2.279,0,0,1,15.2,16.575Z"
        fill="url(#linear-gradient)"
      />
    </svg>
  )
}
export const PostGifIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="22.723"
      height="17.783"
      viewBox="0 0 22.723 17.783"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#4f81fd" />
          <stop offset="1" stopColor="#c03dfd" />
        </linearGradient>
      </defs>
      <path
        id="Union_19"
        data-name="Union 19"
        d="M4.261,17.783A4.355,4.355,0,0,1,0,13.337V4.444A4.356,4.356,0,0,1,4.261,0h14.2a4.355,4.355,0,0,1,4.259,4.444v8.894a4.354,4.354,0,0,1-4.259,4.446ZM1.989,4.444v8.894a2.326,2.326,0,0,0,2.272,2.37h14.2a2.328,2.328,0,0,0,2.273-2.37V4.444a2.327,2.327,0,0,0-2.273-2.37H4.261A2.325,2.325,0,0,0,1.989,4.444ZM14.2,8.892a1.421,1.421,0,1,1,1.419,1.48A1.451,1.451,0,0,1,14.2,8.892Zm-4.261,0a1.421,1.421,0,1,1,1.419,1.48A1.451,1.451,0,0,1,9.942,8.892Zm-4.261,0A1.421,1.421,0,1,1,7.1,10.372,1.451,1.451,0,0,1,5.681,8.892Z"
        fill="url(#linear-gradient)"
      />
    </svg>
  )
}
export const Circle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="13"
      height="13"
      viewBox="0 0 13 13"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#c03dfd" />
          <stop offset="1" stopColor="#4f81fd" />
        </linearGradient>
      </defs>
      <path
        id="Ellipse_709"
        data-name="Ellipse 709"
        d="M6.5,1A5.5,5.5,0,1,0,12,6.5,5.506,5.506,0,0,0,6.5,1m0-1A6.5,6.5,0,1,1,0,6.5,6.5,6.5,0,0,1,6.5,0Z"
        fill="url(#linear-gradient)"
      />
    </svg>
  )
}
export const SetttingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="15.486"
      height="15.486"
      viewBox="0 0 15.486 15.486"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#c03dfd" />
          <stop offset="1" stopColor="#4f81fd" />
        </linearGradient>
      </defs>
      <path
        id="Path_88262"
        data-name="Path 88262"
        d="M-1398.728-104.585v-.046a.3.3,0,0,0-.2-.267l-.044-.017a.3.3,0,0,0-.328.058l-.034.034a2.006,2.006,0,0,1-1.43.592,2.006,2.006,0,0,1-1.43-.592,2.009,2.009,0,0,1-.592-1.43,2.009,2.009,0,0,1,.593-1.43l.033-.033a.3.3,0,0,0,.058-.329l0-.007a.3.3,0,0,0-.274-.181h-.105a2.024,2.024,0,0,1-2.021-2.021,2.024,2.024,0,0,1,2.021-2.021h.047a.3.3,0,0,0,.266-.2c.006-.015.012-.03.018-.044a.3.3,0,0,0-.058-.328l-.034-.034a2.006,2.006,0,0,1-.592-1.43,2.006,2.006,0,0,1,.592-1.43,2.009,2.009,0,0,1,1.43-.592,2.009,2.009,0,0,1,1.43.593l.033.033a.3.3,0,0,0,.329.059.67.67,0,0,1,.124-.042.3.3,0,0,0,.115-.235v-.105a2.024,2.024,0,0,1,2.022-2.021,2.024,2.024,0,0,1,2.021,2.021v.058a.3.3,0,0,0,.181.271l.007,0a.3.3,0,0,0,.328-.058l.034-.034a2.008,2.008,0,0,1,1.43-.593,2.008,2.008,0,0,1,1.43.593,2.008,2.008,0,0,1,.592,1.429,2.009,2.009,0,0,1-.593,1.431l-.033.033a.3.3,0,0,0-.059.328.677.677,0,0,1,.042.125.3.3,0,0,0,.235.114h.105a2.024,2.024,0,0,1,2.021,2.021,2.024,2.024,0,0,1-2.021,2.021h-.058a.3.3,0,0,0-.271.182l0,.007a.3.3,0,0,0,.058.328l.034.034a2.006,2.006,0,0,1,.593,1.43,2.008,2.008,0,0,1-.593,1.43,2.009,2.009,0,0,1-1.43.592,2.009,2.009,0,0,1-1.43-.593l-.033-.033a.3.3,0,0,0-.328-.059l-.008,0a.3.3,0,0,0-.181.274v.1a2.024,2.024,0,0,1-2.021,2.022A2.024,2.024,0,0,1-1398.728-104.585Zm.345-1.713a1.789,1.789,0,0,1,1.155,1.638.127.127,0,0,1,0,.018v.057a.522.522,0,0,0,.521.522.522.522,0,0,0,.521-.522v-.108a1.8,1.8,0,0,1,1.087-1.648,1.8,1.8,0,0,1,.722-.151,1.79,1.79,0,0,1,1.258.513l.006.006.038.038a.519.519,0,0,0,.369.153.516.516,0,0,0,.369-.153.514.514,0,0,0,.154-.369.516.516,0,0,0-.153-.369l-.039-.039-.005-.005a1.791,1.791,0,0,1-.361-1.982,1.8,1.8,0,0,1,1.644-1.085h.06a.522.522,0,0,0,.521-.522.522.522,0,0,0-.521-.521h-.108a1.8,1.8,0,0,1-1.65-1.09.748.748,0,0,1-.052-.185,1.79,1.79,0,0,1,.415-1.842l.006-.006.038-.038a.519.519,0,0,0,.153-.37.515.515,0,0,0-.153-.368.515.515,0,0,0-.369-.154.517.517,0,0,0-.369.153l-.039.039-.005.005a1.788,1.788,0,0,1-1.258.513,1.783,1.783,0,0,1-.723-.152,1.8,1.8,0,0,1-1.086-1.644v-.06a.522.522,0,0,0-.521-.521.522.522,0,0,0-.522.521v.108a1.8,1.8,0,0,1-1.09,1.65.748.748,0,0,1-.185.052,1.789,1.789,0,0,1-.584.1,1.792,1.792,0,0,1-1.258-.513l-.006-.006-.038-.038a.517.517,0,0,0-.369-.153.519.519,0,0,0-.369.152.522.522,0,0,0-.154.37.521.521,0,0,0,.153.369l.039.039.005.005a1.792,1.792,0,0,1,.37,1.963,1.79,1.79,0,0,1-1.638,1.155h-.076a.521.521,0,0,0-.521.521.522.522,0,0,0,.521.521h.109a1.8,1.8,0,0,1,1.648,1.087,1.791,1.791,0,0,1-.362,1.98l-.006.006-.038.038a.517.517,0,0,0-.153.369.516.516,0,0,0,.153.369.518.518,0,0,0,.369.154.52.52,0,0,0,.369-.153l.039-.039.005-.005a1.788,1.788,0,0,1,1.258-.513A1.787,1.787,0,0,1-1398.383-106.3Zm-1.031-4.009a2.66,2.66,0,0,1,2.658-2.657,2.66,2.66,0,0,1,2.657,2.657,2.66,2.66,0,0,1-2.657,2.658A2.661,2.661,0,0,1-1399.415-110.306Zm1.5,0a1.159,1.159,0,0,0,1.157,1.157,1.158,1.158,0,0,0,1.156-1.157,1.157,1.157,0,0,0-1.156-1.157A1.158,1.158,0,0,0-1397.914-110.306Z"
        transform="translate(1404.5 118.049)"
        fill="url(#linear-gradient)"
      />
    </svg>
  )
}
export const LogoutIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="17.143"
      height="15"
      viewBox="0 0 17.143 15"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#c03dfd" />
          <stop offset="1" stopColor="#4f81fd" />
        </linearGradient>
      </defs>
      <path
        id="Icon_open-account-logout"
        data-name="Icon open-account-logout"
        d="M6.429,0V2.143H15V12.857H6.429V15H17.143V0ZM4.286,4.286,0,7.5l4.286,3.214V8.571h8.571V6.429H4.286Z"
        fill="url(#linear-gradient)"
      />
    </svg>
  )
}
